<template>
    <div class="photograph-theme-box">
        <slot name="title"></slot>
        <el-row :gutter="20">
            <el-col v-for="item in themeData" :key="item.id" :xs="24" :sm="12" :md="8">
                <div class="photograph-theme-item">
                    <router-link
                        :to="detailRoute(item)"
                        class="photograph-theme-item-pic-box">
                        <el-image :src="item.coverImageUrl" :alt="item.name" fit="cover" class="photograph-theme-item-pic" lazy>
                            <template v-slot:placeholder><div class="image-slot"><i class="el-icon-loading"></i></div></template>
                            <template v-slot:error><div class="image-slot"><i class="el-icon-picture-outline"></i></div></template>
                        </el-image>
                    </router-link>
                    <div class="photograph-theme-item-text">
                        <router-link
                            :to="detailRoute(item)"
                            class="photograph-theme-item-title">
                            {{item.name}}
                        </router-link>
                        <div class="photograph-theme-item-price clearfix">
                            <span v-if="item.startingAmount !== null && item.startingAmount !== undefined">¥ {{item.startingAmount}} 元起</span>
                            <span v-else>价格以服务端报价为准</span>
                            <router-link
                                :to="detailRoute(item)"
                                class="photograph-theme-item-buy">
                                查看风格 <i class="el-icon-d-arrow-right"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    props: {
        themeTypeId: { type: [String, Number], required: true },
        themeData: { type: Array, default: () => [] },
    },
    methods: {
        detailRoute(item) {
            return { name: "photographDetail", query: { themeTypeId: this.themeTypeId, themeId: item.id } };
        },
    },
};
</script>

<style scoped>
.photograph-theme-item{ margin-bottom: 20px; background: #fff; border-radius: 10px; overflow: hidden; }
.photograph-theme-item-pic-box{ position: relative; display: block; width: 100%; background: #f1f0f5; }
.photograph-theme-item-pic-box::before{ display: block; content: ""; padding-top: 100%; }
.photograph-theme-item-pic{ position: absolute; inset: 0; width: 100%; height: 100%; }
.image-slot{ width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; color: #aaa7b2; font-size: 30px; }
.photograph-theme-item-text{ padding: 15px; text-align: left; }
.photograph-theme-item-title{ display: block; margin-bottom: 20px; overflow: hidden; color: #303133; font-size: 17px; text-overflow: ellipsis; white-space: nowrap; }
.photograph-theme-item-price>span{ float: left; color: #e6a23c; }
.photograph-theme-item-price>a{ float: right; color: #e6a23c; }
.photograph-theme-item-price>a:hover,
.photograph-theme-item-title:hover{ color: #8d9afc; }
</style>
